import { JSX } from "react";
import Confetti from "react-confetti";
import { Button } from "@/shared/ui";
import { CardWrapper } from "../card-wrapper";

interface FinalCardProps {
  onClick: () => void;
}

export const FinalCard = (props: FinalCardProps): JSX.Element => {
  const { onClick } = props;

  return (
    <>
      <Confetti recycle={false} numberOfPieces={500} />
      <CardWrapper title="Thank you" classNames={{ header: "flex justify-center" }}>
        <div className="flex justify-center p-[40px]">
          <Button size="sm" appearance="brand" className="!h-[60px] w-1/2" onClick={onClick}>
            Start New Survey
          </Button>
        </div>
      </CardWrapper>
    </>
  );
};
